<template>
  <div class="order-timeout-container">
    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- 超时状态卡片 -->
      <div class="timeout-card">
        <!-- 标题区域 -->
        <div class="title-section">
          <h1 class="timeout-title">订单已超时</h1>
          <p class="timeout-subtitle">支付时间已过，订单自动取消</p>
        </div>
        
        <!-- 订单信息 -->
        <div class="order-info" v-if="orderNo">
          <div class="info-header">
            <span class="info-icon">📋</span>
            <span class="info-title">订单信息</span>
          </div>
          <div class="info-content">
            <div class="info-item">
              <span class="info-label">订单号</span>
              <span class="info-value">{{ orderNo }}</span>
              <span class="copy-btn" @click.stop="copyOrderNo(orderNo)">复制</span>
            </div>
          </div>
        </div>
        
        <!-- 提示信息 -->
        <div class="tip-section">
          <div class="tip-icon">💡</div>
          <div class="tip-content">
            <h3 class="tip-title">温馨提示</h3>
            <p class="tip-text">订单已超时，请重新从商城首页下单</p>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="action-section">
          <button class="action-btn primary" @click="goToHome">
            <span class="btn-icon">🏠</span>
            <span class="btn-text">返回首页</span>
          </button>
          <button class="action-btn secondary" @click="goToOrderList">
            <span class="btn-icon">📋</span>
            <span class="btn-text">查看订单</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import utils from '@/utils';

export default {
  name: 'orderTimeOut',
  data() {
    return {
      orderInfo: null,
      isProcessing: true,
      loadingText: '请稍候，正在为您处理订单...',
      orderNo: '', // 订单号
    }
  },
  
  mounted() {
    this.initOrderTimeout();
  },
  
  methods: {
    // 初始化订单超时
    initOrderTimeout() {
      // 从路由参数获取订单信息
      this.orderNo = this.$route.query.orderNo;
    },

    // 复制订单号
    copyOrderNo(orderNo) {
      utils.copyText(orderNo, this);
    },
    // 返回首页
    goToHome() {
      this.$router.push('/');
    },
    // 查看订单列表
    goToOrderList() {
      this.$router.push('/AllOrder');
    },
  }
}
</script>

<style lang="scss" scoped>
.order-timeout-container {
  background-color: #f7f8fa;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

/* ========== 主内容区域 ========== */
.main-content {
  width: 100%;
  max-width: 24rem;
}

/* ========== 超时状态卡片 ========== */
.timeout-card {
  background-color: #ffffff;
  border-radius: 1rem;
  padding: 2.5rem 2rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* ========== 标题区域 ========== */
.title-section {
  margin-bottom: 2rem;
}

.timeout-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333333;
  margin-bottom: 0.5rem;
}

.timeout-subtitle {
  font-size: 0.9rem;
  color: #666666;
  margin: 0;
  line-height: 1.4;
}

/* ========== 订单信息 ========== */
.order-info {
  background-color: #f8f9fa;
  border-radius: 0.8rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border: 1px solid #e9ecef;
}

.info-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e9ecef;
}

.info-icon {
  font-size: 1.2rem;
  margin-right: 0.5rem;
}

.info-title {
  font-size: 1rem;
  font-weight: 600;
  color: #333333;
}

.info-content {
  text-align: left;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.info-label {
  font-size: 0.9rem;
  color: #666666;
  font-weight: 500;
}

.info-value {
  font-size: 0.9rem;
  color: #333333;
  font-weight: 600;
}

/* ========== 提示信息 ========== */
.tip-section {
  background-color: #fff3cd;
  border-radius: 0.8rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border: 1px solid #ffeaa7;
  display: flex;
  align-items: flex-start;
  text-align: left;
}

.tip-icon {
  font-size: 1.5rem;
  margin-right: 1rem;
  margin-top: 0.1rem;
}

.tip-content {
  flex: 1;
}

.tip-title {
  font-size: 1rem;
  font-weight: 600;
  color: #856404;
  margin: 0 0 0.5rem 0;
}

.tip-text {
  font-size: 0.9rem;
  color: #856404;
  line-height: 1.5;
  margin: 0;
}

/* ========== 操作按钮 ========== */
.action-section {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.action-btn {
  flex: 1;
  min-width: 8rem;
  padding: 1rem 1.5rem;
  border: none;
  border-radius: 0.8rem;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:active {
    transform: scale(0.98);
  }
}

.action-btn.primary {
  background-color: #ff6b6b;
  color: white;
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);

  &:hover {
    background-color: #ff5252;
    box-shadow: 0 4px 12px rgba(255, 107, 107, 0.4);
  }
}

.action-btn.secondary {
  background-color: #f8f9fa;
  color: #666666;
  border: 1px solid #e9ecef;

  &:hover {
    background-color: #e9ecef;
    color: #333333;
  }
}

.btn-icon {
  font-size: 1rem;
}

.btn-text {
  font-weight: 600;
}

/* ========== 响应式设计 ========== */
@media (max-width: 480px) {
  .timeout-card {
    padding: 2rem 1.5rem;
  }

  .action-section {
    flex-direction: column;
  }

  .action-btn {
    min-width: auto;
  }
}

.copy-btn {
  margin-left: 0.5rem;
  padding: 0.1rem 0.4rem;
  background: rgba(102, 102, 102, 0.1);
  color: #666;
  font-size: 0.75rem;
  border-radius: 0.3rem;
  border: 1px solid rgba(102, 102, 102, 0.3);
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  display: inline-block;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.copy-btn:active {
  background: rgba(102, 102, 102, 0.2) !important;
  transform: scale(0.95) !important;
}
</style>
